import moment from "moment-timezone";
import { getPrimaryActiveResource } from "../../../../../utils/helpers/user";
import { combineDateAndTime, renderDurationAsFormat } from "../../../../../utils/helpers/date";

export const getDefaultSectionForUser = ({
    user,
    date,
    company,
    allocatedGroups,
    defaultPayCode,
}: {
    user: any;
    date: any;
    company: any;
    allocatedGroups: any[];
    defaultPayCode: any;
}) => {
    const primaryJob = getPrimaryActiveResource(user?.jobs || []);
    const primaryLocation = getPrimaryActiveResource(user?.locations || []);

    const levels =
        allocatedGroups?.reduce((total: any, group: any) => {
            const level = group?.level.replace("_", "");
            if (user?.[level]) total[level] = user[level];
            return total;
        }, {}) ?? {};

    const calcGroup = user?.calculationGroup;
    const scheduleSettings = calcGroup?.schedule || company?.settings?.schedule;

    const shiftStart = scheduleSettings?.shiftStart
        ? moment.parseZone(scheduleSettings.shiftStart)
        : moment().startOf("day").hour(9);

    const shiftEnd = scheduleSettings?.shiftEnd
        ? moment.parseZone(scheduleSettings.shiftEnd)
        : moment().startOf("day").hour(17);

    const start = combineDateAndTime(moment(date), shiftStart);
    const end = combineDateAndTime(moment(date), shiftEnd);

    return {
        type: "regular",
        payCode: defaultPayCode,
        location: primaryLocation,
        job: primaryJob,
        start,
        end,
        duration: renderDurationAsFormat(
            moment(end).diff(start, "seconds"),
            "HH:mm"
        ),
        ...levels,
    };
};
